import React from 'react'
import { auth } from '../firebase-config'
import { sendPasswordResetEmail } from 'firebase/auth'
import { object, string } from 'yup'
import { useFormik } from 'formik'
import { Link } from 'react-router-dom'
import { Button } from '../components/Button'
import { Input } from '../components/Input'
import { Error } from '../components/Error'
import styles from '../components/Button.module.css'
import stylesUserSignUp from '../container/UserSignUp.module.css'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

const requiredMsg = 'Dieses Feld ist verpflichtend'

const userSchema = object({
  email: string().email('Muss eine gültige E-Mail sein').required(requiredMsg),
})

const initialValues = {
  email: '',
}

async function handleSubmit(email) {
  sendPasswordResetEmail(auth, email)
    .then(() => {
      toast.success('Wir haben die eine E-Mail gesendet', {
        position: 'top-center',
      })
    })
    .catch((error) => {
      console.log(error)

      toast.error(
        'Leider konnten wir deine Eingaben nicht verarbeiten. Bitte versuche es erneut.',
        {
          position: 'top-center',
        },
      )
    })
}

export const PasswordReset = ({ onSubmit = handleSubmit }) => {
  const formik = useFormik({
    initialValues,
    validationSchema: userSchema,
    onSubmit: (values) => onSubmit(values.email),
  })

  return (
    <>
      <form
        className={stylesUserSignUp.usersignup}
        onSubmit={formik.handleSubmit}
      >
        <div>
          <Input
            name='email'
            type='email'
            label='E-Mail'
            placeholder='mustershop@email.com'
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.email}
            required={true}
          />
          {formik.touched.email && formik.errors.email && (
            <Error msg={formik.errors.email} />
          )}
        </div>

        <Button type='submit'>E-Mail senden</Button>
      </form>
      <Link to="/sign-in" className={styles.passwordReset}>
        <Button>Abbrechen</Button>
      </Link>
    </>
  )
}
